import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  modalTitle: {
    zIndex: 1,
    position: 'absolute',
    top: '0',
    left: '24px',
    marginBottom: '0px',
    width: 'calc(100% - 48px)',
    paddingTop: '24px',
    paddingBottom: '8px',
    fontSize: theme.size.lg,
    color: '#3C425B',
    background: 'white'
  },

  modalClose: {
    top: '24px',
    right: '24px',
    zIndex: 2
  },

  mobileChildren: {
    height: '100svh',
    maxHeight: 'unset'
  },

  root: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '40px',
    padding: '24px'
  },

  mobileRoot: {
    marginTop: '0',
    paddingTop: '0'
  },

  mobileTitle: {
    display: 'flex',
    alignItems: 'center',
    margin: '16px 0 22px 0',

    '& > span': {
      fontSize: theme.size.lg,
      color: '#1F1F1F'
    }
  },

  mobileBackArrow: {
    marginRight: '16px',
    cursor: 'pointer'
  },

  cards: {
    display: 'grid',
    gridTemplateColumns: '1fr 56px 1fr',
    marginBottom: '24px'
  },

  mobileCards: {
    display: 'flex',
    flexDirection: 'column'
  },

  cardTitle: {
    marginBottom: '8px',
    fontSize: theme.size.base,
    color: '#1F1F1F'
  },

  arrow: {
    alignSelf: 'center',
    margin: '0 16px'
  },

  info: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '90px',
    borderRadius: '4px',
    padding: '16px',
    background: '#F0F0F0'
  },

  infoTitle: {
    marginBottom: '16px',
    fontSize: theme.size.base,
    color: '#1F1F1F'
  },

  infoPoints: {
    margin: '0',
    padding: '0',
    paddingLeft: '16px',
    fontSize: theme.size.base,
    color: '#1F1F1F',

    '& > :not(:last-child)': {
      marginBottom: '8px'
    },

    '& .bold': {}
  },

  buttonArea: {
    zIndex: 1,
    position: 'absolute',
    bottom: '-1px',
    left: '-1px',
    right: '-1px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    columnGap: '8px',
    height: '96px',
    paddingRight: '24px',
    background: '#F5F6F8',
    borderRadius: '0px 0px 8px 8px'
  },

  buttonAreaMobile: {
    justifyContent: 'center',
    position: 'absolute',
    bottom: '2px',
    left: '24px',
    right: '24px',
    margin: '0',
    height: 'auto',
    padding: '14px 0',
    background: 'white'
  },

  button: {
    flex: '1',
    height: '48px',
    maxWidth: '164px'
  },

  fullWidthButton: {
    width: '100%',
    maxWidth: 'unset'
  },

  submodalTitle: {
    marginTop: '72px',
    marginBottom: '8px',
    fontSize: theme.size.lg,
    textAlign: 'center',
    color: '#1F1F1F'
  },

  submodalText: {
    marginBottom: '16px',
    fontSize: theme.size.base,
    textAlign: 'center',
    color: '#1F1F1F'
  },

  submodalUsers: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 'calc(24px + 96px)'
  },

  submodalUser: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',

    '& .name': {
      marginTop: '8px',
      fontSize: theme.size.sm,
      color: '#1F1F1F'
    }
  },

  submodalAvatar: {
    width: '48px',
    height: '48px'
  },

  submodalArrow: {
    marginLeft: '16px',
    marginRight: '16px'
  },

  buttonAreaSub: {
    justifyContent: 'center',
    columnGap: '16px',
    padding: '0'
  },

  submodalButton: {
    minWidth: '200px',

    '&:first-child': {
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main
    }
  },

  submodalButtonMobile: {
    minWidth: 'unset'
  },

  submodalButtonAreaMobile: {
    columnGap: '9px',
    padding: '0 22px'
  }
}))

export default useStyles
